export default function reducer(state = {
  proveedores: [],
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_PROVEEDORES": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}